/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Issue_Extraction_OffInputs */

const en_inbound_issue_extraction_off = /** @type {(inputs: Inbound_Issue_Extraction_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the extraction tool is off`)
};

/**
* | output |
* | --- |
* | "the extraction tool is off" |
*
* @param {Inbound_Issue_Extraction_OffInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_issue_extraction_off = /** @type {((inputs?: Inbound_Issue_Extraction_OffInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Issue_Extraction_OffInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_issue_extraction_off(inputs)
});